import React from 'react';
const IconRatingThumbsUpFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 20H4V9H2V20ZM19 7H15V4C15 3.46957 14.7893 2.96086 14.4142 2.58579C14.0391 2.21071 13.5304 2 13 2H11.57L6 8.64V20H16.47L22 13.4V10C22 9.20435 21.6839 8.44129 21.1213 7.87868C20.5587 7.31607 19.7956 7 19 7Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconRatingThumbsUpFill;